import { gql } from 'apollo-boost';

export const CREATE_USER_FORM_ANSWER = gql`
  mutation doCreateUserFormAnswer($data: UserFormAnswerSubmission!) {
    createUserFormAnswer(data: $data) {
      id
    }
  }
`;
